module.exports = __webpack_public_path__ + "static/img/微信图片_202207220841542.57da26a2.jpg";